import type { enOperator } from '../en/operator.js';

export const deOperator: Record<keyof typeof enOperator, string> = {
  'o.title': 'Betreiber-Konsole',
  'o.nav': 'Bereiche',
  'o.email': 'E-Mail',
  'o.password': 'Passwort',
  'o.login.sub': 'Melden Sie sich mit Ihrem Betreiberkonto an. Das ist getrennt von jedem Restaurant-Dashboard.',
  'o.login.go': 'Anmelden',
  'o.logout': 'Abmelden',
  'o.tab.customers': 'Kunden',
  'o.tab.plans': 'Tarife',
  'o.tab.invoices': 'Rechnungen',
  'o.status.active': 'Aktiv',
  'o.status.trial': 'Testphase',
  'o.status.suspended': 'Gesperrt',
  'o.status.cancelled': 'Gekündigt',
  'o.status.draft': 'Entwurf',
  'o.status.open': 'Offen',
  'o.status.paid': 'Bezahlt',
  'o.status.void': 'Storniert',
  'o.trial_until': 'bis {date}',
  'o.search': 'Kunden suchen',
  'o.new_customer': '+ Neuer Kunde',
  'o.none': 'Noch nichts vorhanden.',
  'o.col.customer': 'Kunde',
  'o.col.status': 'Status',
  'o.col.plan': 'Tarif',
  'o.col.bookings': 'Buchungen diesen Monat',
  'o.col.domains': 'Domains',
  'o.col.since': 'Kunde seit',
  'o.bookings_one': '{n} Buchung',
  'o.bookings_other': '{n} Buchungen',
  'o.cancel': 'Abbrechen',
  'o.close': 'Schließen',
  'o.done': 'Fertig',
  'o.save': 'Speichern',
  'o.saved': 'Gespeichert.',
  'o.copy': 'Kopieren',
  'o.copied': 'Kopiert.',
  'o.nc.intro': 'Legt das Restaurant mit einem kleinen funktionierenden Start an (ein Gastraum, sechs Tische, Mittag und Abend), dem gewählten Design und einem Inhaberkonto. Alles Weitere ändert der Kunde in seinem eigenen Dashboard.',
  'o.nc.name': 'Restaurantname',
  'o.nc.timezone': 'Zeitzone',
  'o.nc.currency': 'Währung',
  'o.nc.locale': 'Hauptsprache',
  'o.nc.owner_email': 'E-Mail des Inhabers',
  'o.nc.owner_name': 'Name des Inhabers',
  'o.nc.legal': 'Firmenname',
  'o.nc.address': 'Adresse',
  'o.nc.phone': 'Telefon',
  'o.nc.contact_email': 'Kontakt-E-Mail',
  'o.nc.website': 'Webseite',
  'o.nc.look': 'Ausgangsdesign',
  'o.nc.plan': 'Tarif',
  'o.nc.no_plan': 'Noch kein Tarif',
  'o.nc.trial': 'Testtage',
  'o.nc.billing_email': 'Rechnungs-E-Mail',
  'o.nc.create': 'Kunde anlegen',
  'o.created.title': 'Kunde angelegt',
  'o.created.body': 'Geben Sie diese Angaben an den Kunden weiter. Das Passwort wird nur jetzt angezeigt.',
  'o.created.owner': 'Inhaber',
  'o.created.password': 'Passwort',
  'o.created.dashboard': 'Dashboard',
  'o.created.page': 'Buchungsseite',
  'o.created.embed': 'Code für die Webseite',
  'o.d.links': 'Links',
  'o.d.account': 'Konto',
  'o.d.status': 'Status',
  'o.d.trial_end': 'Testphase endet',
  'o.d.company': 'Firma für Rechnungen',
  'o.d.notes': 'Interne Notizen',
  'o.d.reason': 'Interner Grund',
  'o.d.domains': 'Eigene Domain',
  'o.d.domains_hint': 'Die Buchungsseite des Kunden kann unter dessen eigener Adresse laufen. Fügen Sie die Domain hinzu, legen Sie den angezeigten DNS-Eintrag an und prüfen Sie ihn dann. Richten Sie die Domain auf {host}.',
  'o.d.hostname': 'Domainname',
  'o.d.add_domain': 'Domain hinzufügen',
  'o.d.no_domains': 'Keine Domain verbunden.',
  'o.d.verified': 'Bestätigt',
  'o.d.pending': 'Wartet auf DNS',
  'o.d.txt_hint': 'Legen Sie diesen DNS-Eintrag beim Anbieter der Domain an und drücken Sie dann Prüfen:',
  'o.d.verify': 'Prüfen',
  'o.d.verified_ok': 'Domain bestätigt. Sie bedient jetzt diesen Kunden.',
  'o.d.verified_no': 'Der DNS-Eintrag wurde noch nicht gefunden. Es kann etwas dauern, bis er sichtbar ist.',
  'o.d.remove': 'Entfernen',
  'o.d.remove_confirm': 'Diese Domain entfernen? Die Seite des Kunden antwortet dann nicht mehr darauf.',
  'o.d.owners': 'Inhaberkonten',
  'o.d.new_password': 'Neues Passwort ausstellen',
  'o.d.password_confirm': 'Ein neues Passwort für {email} ausstellen? Die laufenden Sitzungen werden beendet.',
  'o.d.password_shown': 'Neues Passwort für {email} (jetzt kopieren, es wird nicht erneut angezeigt):',
  'o.d.usage': 'Buchungen pro Monat',
  'o.d.invoices': 'Rechnungen',
  'o.d.no_invoices': 'Noch keine Rechnungen.',
  'o.p.intro': 'Tarife legen den Monatspreis fest, wie viele Buchungen enthalten sind und was jede weitere Buchung kostet. Nur aktive Tarife können für neue Kunden gewählt werden.',
  'o.p.name': 'Name',
  'o.p.price': 'Monatspreis',
  'o.p.included': 'Enthaltene Buchungen',
  'o.p.overage': 'Preis je weitere Buchung',
  'o.p.active': 'Aktiv',
  'o.p.add': '+ Tarif hinzufügen',
  'o.p.new': 'Neuer Tarif',
  'o.i.period': 'Monat',
  'o.i.run': 'Entwürfe erstellen oder aktualisieren',
  'o.i.ran': '{drafted} erstellt, {skipped} übersprungen.',
  'o.i.hint': 'Entwürfe werden aus den nicht stornierten Buchungen des Monats berechnet und können aktualisiert werden. Mit dem Ausstellen erhält die Rechnung ihre rechtliche Nummer und wird festgeschrieben; Fehler werden mit einer Gutschrift korrigiert. Kunden in einer laufenden Testphase werden übersprungen.',
  'o.i.all': 'Alle',
  'o.i.lines': 'Positionen',
  'o.i.total': 'Summe',
  'o.i.issue': 'Ausstellen',
  'o.i.paid': 'Als bezahlt markieren',
  'o.i.void': 'Stornieren',
  'o.i.void_confirm': 'Diese Rechnung stornieren?',
  'o.tab.settings': 'Rechnungseinstellungen',
  'o.status.issued': 'Ausgestellt',
  'o.status.credited': 'Gutgeschrieben',
  'o.vat.auto': 'Automatisch',
  'o.vat.standard': 'Normale Umsatzsteuer',
  'o.vat.reverse_charge': 'Reverse Charge',
  'o.vat.outside_scope': 'Nicht steuerbar',
  'o.vat.exempt': 'Steuerfrei',
  'o.collection.manual': 'Manuell (Überweisung)',
  'o.collection.auto': 'Automatisch (gespeicherte Karte oder Lastschrift)',
  'o.d.billing_data': 'Rechnungsdaten',
  'o.d.billing_address': 'Rechnungsadresse',
  'o.d.country': 'Land (ISO-Code)',
  'o.d.vat_id': 'USt-IdNr.',
  'o.d.vat_treatment': 'Umsatzsteuer',
  'o.d.collection': 'Zahlungseinzug',
  'o.d.method': 'Zahlungsmittel',
  'o.d.method_saved': 'Gespeichert',
  'o.d.method_none': 'Noch keine Karte und kein Bankkonto gespeichert.',
  'o.d.method_link': 'Link zum Speichern eines Zahlungsmittels erstellen',
  'o.d.method_replace': 'Link zum Ersetzen erstellen',
  'o.d.method_forget': 'Gespeichertes Zahlungsmittel entfernen',
  'o.d.method_hint': 'Senden Sie den Link an den Kunden. Die Angaben macht er auf der eigenen Seite des Zahlungsanbieters; dieser Server sieht sie nie.',
  'o.d.no_provider': 'Der automatische Einzug ist auf diesem Server nicht eingerichtet. Rechnungen werden überwiesen und von Hand als bezahlt markiert.',
  'o.d.method_link_shown': 'Senden Sie diesen Link an den Kunden (jetzt kopieren):',
  'o.d.method_forget_confirm': 'Das gespeicherte Zahlungsmittel entfernen? Der Kunde wird auf manuelle Zahlung umgestellt.',
  'o.i.no_number': 'Entwurf',
  'o.i.credit_note': 'Gutschrift',
  'o.i.issuer_missing': 'Rechnungen können erst ausgestellt werden, wenn Ihre Firmendaten vollständig sind.',
  'o.i.number': 'Nummer',
  'o.i.net': 'Netto',
  'o.i.vat': 'MwSt.',
  'o.i.collect': 'Jetzt einziehen',
  'o.i.credit': 'Gutschrift',
  'o.i.delete': 'Entwurf löschen',
  'o.i.delete_confirm': 'Diesen Entwurf löschen?',
  'o.i.credit_confirm': 'Diese Rechnung mit einer Gutschrift stornieren? Das kann nicht rückgängig gemacht werden.',
  'o.i.issued': 'Als {number} ausgestellt.',
  'o.i.credited': 'Gutschrift {number} erstellt.',
  'o.i.collect_paid': 'Bezahlt.',
  'o.i.collect_processing': 'Die Zahlung wird verarbeitet; sie wird als bezahlt markiert, sobald der Anbieter sie bestätigt.',
  'o.i.collect_failed': 'Die Zahlung ist nicht durchgegangen. Die Meldung steht an der Rechnung.',
  'o.i.collect_skipped': 'Nichts einzuziehen: kein gespeichertes Zahlungsmittel oder die Rechnung ist nicht offen.',
  'o.s.title': 'Wer die Rechnungen ausstellt',
  'o.s.hint': 'Diese Angaben stehen auf jeder Rechnung und Gutschrift. Rechnungen können erst nummeriert werden, wenn Firmenname, Adresse, Land und eine USt-IdNr. oder Steuernummer ausgefüllt sind.',
  'o.s.missing': 'Es fehlt noch: {fields}.',
  'o.s.f.legalName': 'Firmenname',
  'o.s.f.country': 'Land (ISO-Code)',
  'o.s.f.vatId': 'USt-IdNr.',
  'o.s.f.taxNumber': 'Steuernummer',
  'o.s.f.address': 'Adresse',
  'o.s.f.email': 'E-Mail',
  'o.s.f.phone': 'Telefon',
  'o.s.f.website': 'Webseite',
  'o.s.f.bankName': 'Bank',
  'o.s.f.iban': 'IBAN',
  'o.s.f.bic': 'BIC',
  'o.s.f.vatRate': 'Normaler Umsatzsteuersatz (%)',
  'o.s.f.terms': 'Zahlungsziel (Tage)',
  'o.s.f.invoicePrefix': 'Präfix der Rechnungsnummer',
  'o.s.f.creditPrefix': 'Präfix der Gutschriftsnummer',
  'o.s.f.exemptNote': 'Hinweistext bei Steuerfreiheit',
  'o.s.f.footerNote': 'Fußzeile der Rechnung',
  'o.s.bank': 'Bankverbindung',
  'o.s.rules': 'Umsatzsteuer und Nummerierung',
  'o.s.advice': 'Die Nummern laufen lückenlos je Jahr und Nummernkreis (zum Beispiel RE-2026-00001). Die Umsatzsteuerbehandlung ist eine Hilfe nach den üblichen Regeln für Softwareleistungen zwischen Unternehmen in der EU. Lassen Sie die Einstellungen von Ihrer Steuerberatung bestätigen, bevor Sie echte Rechnungen ausstellen.',
  'o.s.provider': 'Automatischer Einzug',
  'o.s.provider_on': 'Verbunden: {name}.',
  'o.s.provider_off': 'Nicht verbunden. Setzen Sie BILLING_STRIPE_SECRET_KEY und BILLING_WEBHOOK_SECRET auf dem Server, um per Karte oder Lastschrift einzuziehen.',
  'o.i.zugferd_title': 'PDF mit angehängten Rechnungsdaten als XML (ZUGFeRD / Factur-X)',
  'o.i.xr_title': 'XML-Rechnung für die elektronische Rechnung (XRechnung)',
  'o.tab.health': 'System',
  'o.h.none': 'Die Zustandsdaten konnten nicht geladen werden.',
  'o.h.db': 'Datenbank',
  'o.h.down': 'Nicht erreichbar',
  'o.h.sweep': 'Hintergrundaufgaben zuletzt gelaufen',
  'o.h.started': 'Server gestartet',
  'o.h.alerts': 'Alarme aufs Handy oder in den Chat',
  'o.h.on': 'An',
  'o.h.off': 'Aus',
  'o.h.emails_pending': 'Wartende E-Mails',
  'o.h.emails_failed': 'Fehlgeschlagene E-Mails (24 Std.)',
  'o.h.sms_failed': 'Fehlgeschlagene SMS (24 Std.)',
  'o.h.hooks_failed': 'Fehlgeschlagene Webhooks (24 Std.)',
  'o.h.invoices_failed': 'Nicht eingezogene Rechnungen',
  'o.h.alerts_hint': 'Setzen Sie ALERT_WEBHOOK_URL (ein Slack-, Teams- oder Discord-Webhook) am Server, um benachrichtigt zu werden, wenn etwas ausfällt, auch wenn niemand diese Seite offen hat.',
  'o.h.problems': 'Letzte Probleme',
  'o.h.no_problems': 'Seit dem Start des Servers ist nichts schiefgelaufen.',
  'o.d.dummy': 'Testdaten',
  'o.d.dummy_hint': 'Nur für Test-Restaurants: füllt das Restaurant mit Raumplänen, Tischen, Schichten, Gästen, Buchungen der letzten drei und der nächsten zwei Wochen, Umsätzen, einer Speisekarte und Veranstaltungen. Layout und Schichten werden ersetzt (die alte Version bleibt im Verlauf). Wird abgelehnt, wenn echte Reservierungen existieren.',
  'o.d.dummy_load': 'Testdaten laden',
  'o.d.dummy_remove': 'Testdaten entfernen',
  'o.d.dummy_confirm': 'Testdaten in dieses Restaurant laden? Layout und Schichten werden ersetzt.',
  'o.d.dummy_working': 'Lädt … das dauert bis zu einer Minute.',
  'o.d.dummy_done': 'Fertig: {guests} Gäste, {bookings} Buchungen, {tables} Tische.',
  'o.d.dummy_remove_confirm': 'Alle Test-Gäste, -Buchungen und -Umsätze wieder entfernen? Layout und Schichten bleiben.',
  'o.d.dummy_removed': '{n} Einträge entfernt.',
  'o.i.email': 'Per E-Mail senden',
  'o.i.emailed': 'Per E-Mail an {to} gesendet',
  'o.i.email_failed': 'E-Mail nicht gesendet: {error}',
  'o.i.email_sent': 'E-Mail mit angehängtem PDF gesendet.',
  'o.i.email_not_sent': 'Die E-Mail konnte nicht gesendet werden. Die Meldung steht an der Rechnung.',
  'o.d.link': 'Konten verknüpfen',
  'o.d.link_hint': 'Diese Person kann zwischen allen Restaurants wechseln, in denen sie diese E-Mail nutzt, ohne sich neu anzumelden.',
  'o.d.linked': '{n} Kontoverknüpfungen angelegt.',
};
